/**
 * Event requests
 */
import API from '@/api/base.js';
import CONFIG from '@/constants/config.js';

export default {
    getSpotsByEventId(id){
        let data={
            eventId:id
        };
        return API.get(`/appwaypoint/getallwaypoints/${CONFIG.PARAM_NAME_EVENT_ID}/${id}`,data,`Spots by event ID ${id}`);
    },
    checkinSpotById(id,eventId,data={}){
        data.eventId=eventId;
        return API.post(`/appwaypoint/checkin/${CONFIG.PARAM_NAME_EVENT_ID}/${eventId}/${CONFIG.PARAM_NAME_WP_ID}/${id}`,data,`Checkin spot ${id}`,true);
    },
    solveSpotById(id,eventId,data){
        data.eventId=eventId;
        return API.post(`/appwaypoint/solve/${CONFIG.PARAM_NAME_EVENT_ID}/${eventId}/${CONFIG.PARAM_NAME_WP_ID}/${id}`,data,`Solve spot ${id}`,true,true,CONFIG.SOLVE_REQUEST_TIMEOUT);
    },
    requestHintById(hintId, wpId, eventId, data={}){
        data.eventId = eventId;
        return API.post(`/appwaypoint/usehint/${CONFIG.PARAM_NAME_EVENT_ID}/${eventId}/${CONFIG.PARAM_NAME_WP_ID}/${wpId}/${CONFIG.PARAM_NAME_HINT_ID}/${hintId}`,data,`Request hint ${hintId}`,true);
    }
}